export default {
  "X-HW-APPKEY": "TEVfcmdqRVBFYSNhJX5kaA==", //saas
  "X-HW-ID": "com.huawei.mtl.sinobase", //saas
  exhibitionId: "2022ECOP",
  seminarId: 2202102963240899, //线下会id
  onlineSeminarId: 2202100755108144,
  //instanceId: 136829,
  intoduceId: 2203091841538039, //大会介绍
  newsId: 2203033789641362, //热门资讯
  videosId: 2203032133416870, //精彩视频
  guestListId: 2202102963240899, //嘉宾列表
  bigViewId: 2206021896743464, //大咖观点
  advListId: 2206020425042404, //首页广告id
  tenantId: 519,
  schemaId: 318,
  weChatId: 6030,
  memberFormId: 7241,
  agendaSeachID: "280304", //议程搜索字典id
  partnerId: 2203032800366023, //首页合作伙伴id
  subPartnerId: 2205311001062071, //分会场合作伙伴根目录id
  mediaId: 2206111148404516, ////首页大会媒体id todo 上线配置
  morningMainSeminarId: 2206023831519269,
  afternoonMainSeminarId: 2206020304305859,
  cityTravelDictId: 280612, //伙伴百城行 字典id
  cityTravelArticleId: 2206190729407228, //伙伴百城行 文章栏目id
  cityTravelSearchTypeId: 280603, //伙伴百城行 筛选类型字典id
  cityTravelSearchIndustryId: 280767, //伙伴百城行 筛选行业字典id
  cityTravelSearchpProductId: 280781, //伙伴百城行 筛选产品字典id
  cityTravelProvince: 280165, //伙伴百城行 省份字典id
  articleRelation: {
    "华为张平安：深耕数字化，一切皆服务":
      "https://www.huaweicloud.com/news/2021/20210923084935881.html",
    昇腾行业AI赋能试验平台助力浙江移动推出数智赋能服务:
      "https://client.sina.cn/news/2022-05-20/detail-imcwiwst8459484.d.html",
  },
  agendaDateList: [
    {
      id: 0,
      day: "2022-06-15",
    },
    {
      id: 1,
      day: "2022-06-16",
    },
    // {
    //   id: 2,
    //   day: "2022-06-17",
    // },
  ],
  mapUrl:
    "https://www.amap.com/search?id=B02F37TV2J&city=440304&geoobj=114.171059%7C38.690953%7C120.323403%7C41.200437&query_type=IDQ&query=%E6%B7%B1%E5%9C%B3%E4%BC%9A%E5%B1%95%E4%B8%AD%E5%BF%83&zoom=8",
  guide: {
    notice: {
      content: 2203210084116834,
      after: {
        tips: 2203212612761680,
      },
      in: {
        tips: 2203210347664437,
      },
      before: {
        freeTesting: 2203212609982575, //核算检测点
        paymentTesting: 2203213140998300, //检测医院
        subObj: 2203211135538627, //会前须知
        tips: 2203213193927466, //提示
      },
    },
  },
  cookie: {
    domain: document.domain === "localhost" ? "localhost" : ".huawei.com",
  },
  shareConfig: {
    title: "首届 “华为伙伴暨开发者大会” 来啦！",
    desc: "因聚而生 为你所能", // 描述信息
    imgUrl: `https://e-campaign.huawei.com/campaign/partner-developer2022/images/shareIcon.png`, // 分享的小图标
  },
  homePage: "https://e-campaign.huawei.com/campaign/partner-developer2022/", //todo 上线打开
  //homePage: "https://e-campaign.huawei.com/campaign/uat/partner-developer2022/", //todo 上线替换会正式 ↑
  loginUrl: "https://app.events.huawei.com/partner-developer2022/login",
  syUrl:
    "https://e-campaign.huawei.com/campaign/partner-developer2022/cloud-form", //我要上云 url
  ticketedUrl: "https://sale.vmall.com/partner-developer2022.html", //购票链接
  dictInfoUrl: "https://hwyhw-static.smarket.net.cn/519/dic/list/224346.json", //省份地址信息
  signUpOnlineUrl: "https://app.events.huawei.com/partner-developer2022/login",
  signUpOfflineUrl:
    "https://app.events.huawei.com/partner-developer2022/offline/verifyCode",
  uniportalSignOut:
    "https://api-eventsapp-project.smarket.net.cn/hwid/loginOut?sess=", //以 uniportal 登录 方式 退出的
  signOnlineUrl:
    "https://app.events.huawei.com/partner-developer2022/online/sign",
  verificationCodeUrl:
    "https://api-eventsapp-project.smarket.net.cn/vmall/simpleSignUp", //核验票码 接口
  getQrcode:
    "https://api-eventsapp-project.smarket.net.cn/vmall/seminar/contacts/getqrcode", //获取门票二维码
  partnerUrl:
    "https://e-campaign.huawei.com/campaign/partner2021-minisite-1/home", //华为生态
  HDCUrl: "https://developer.huaweicloud.com/HDC.Cloud2021.html", //HDC
  // svgMapUrl:
  //   "https://e-campaign.huawei.com/campaign/test/partner-developer2022/", //svg地图 路径 test  todo 上正式前替换
  svgMapUrl: "https://e-campaign.huawei.com/campaign/partner-developer2022/", //svg地图 路径 sass  todo 上正式前替换
  //svgMapUrl: window.location.protocol + "//" + window.location.host + "/", //svg地图 路径
  signUpOfflineUrl_new:
    "https://app.events.huawei.com/partner-developer2022/offline/sign",
  // vhallUrl: "https://live.huawei.com/HPDC/meeting/cn/",
  vhallUrl: "https://live.huawei.com/HPDC/meeting/cn/", //TODO 上正式替换
  // introduceVideo:
  // "https://1500010779.vod2.myqcloud.com/6ca9a800vodcq1500010779/381f2807387702301864511550/vVqMURoEY8kA.mp4",
  introduceVideo:
    "https://1500010779.vod2.myqcloud.com/439395a8vodtranscq1500010779/381f2807387702301864511550/v.f80000.mp4",
  api: {
    gateway: {
      general: "https://hw-hwyapi.smarket.net.cn",
      project: "https://hwproject-api.smarket.net.cn",
      JsonUrl: "https://hwyhw-static.smarket.net.cn/",
      hwUrl: "https://apigw.huawei.com",
    },
    ungateway: {
      contentUrl: "https://s2-content.smarket.net.cn/index.php",
    },
  },
  weChatOauthUrl: "https://f.smarket.net.cn/memberb/public/wx_interface/auth",
  warningLog: {
    accessToken: "",
    title: "测试页面报警",
    ignoreList: {
      "/member/login": "401", // 第三方用户登录 未绑定
      "/article/getCollectionList": "268451864", // 文章收藏列表为空
    },
  },
  isStatic: true,
  isSK: true,
  activityId: 12, //互动活动id
  interactionUrl:
    "https://app.events.huawei.com/partner-developer2022-interaction",
};
